import FirebaseContext from './context';
import Firebase, { AuthUser } from './firebase';

export default Firebase;

export { FirebaseContext };
export type AuthUserType = AuthUser;
